import { isEmpty } from 'helpers';
import { ContractType } from 'types/IProducts';

const ITEMS_PER_STEP = 4;

const monthNamesShort = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const getCustomSymbolNameGenerator = ({ product, contractType }) => {
  const splittedSymbol = product.symbol.split('-');

  let formattedSymbol = '';

  if (contractType === ContractType.OptionsCombos) {
    formattedSymbol += splittedSymbol[0];
    formattedSymbol += `-${splittedSymbol[2]}-${splittedSymbol[3]}`;
    const settlementTime = new Date(product.settlement_time);

    formattedSymbol += `-${settlementTime.getDate()} ${
      monthNamesShort[settlementTime.getMonth()]
    }`;

    return formattedSymbol;
  }

  formattedSymbol += splittedSymbol[0];
  formattedSymbol += `-${splittedSymbol[2]}`;
  const settlementTime = new Date(product.settlement_time);
  formattedSymbol += `-${settlementTime.getDate()} ${
    monthNamesShort[settlementTime.getMonth()]
  }`;

  return formattedSymbol;
};

export const getProductType = product => {
  if (isEmpty(product)) return null;

  const symbolSeperator = product?.symbol?.split('-');

  switch (symbolSeperator?.[0]) {
    case 'C':
      return ContractType.CallOptions;
    case 'P':
      return ContractType.PutOptions;
    default:
      return null;
  }
};

export const filterTopGainersByStep = (step, data = []) => {
  const start = (step - 1) * ITEMS_PER_STEP;
  const end = start + ITEMS_PER_STEP;
  return Array.isArray(data) ? data.slice(start, end) : [];
};
